import { Component, AfterViewInit, ElementRef, HostListener, Output, EventEmitter, ViewChild } from '@angular/core';
import { WindowResize } from './screen-size.';
declare var $: any;

@Component({
    selector: 'ups-resize-window',
    template: require('./ups-resize-window.component.html')
})

export class UpsResizeWindowComponent implements AfterViewInit {

    @Output() windowChanged: EventEmitter<WindowResize> = new EventEmitter<WindowResize>();
    //@ViewChild('users-device-size') elementView: ElementRef;

    constructor(private elementRef: ElementRef) { }

    @HostListener("window:resize")
    private onResize() {
        this.detectScreenSize();
    }

    ngAfterViewInit() {
        this.detectScreenSize();
    }

    private detectScreenSize() {
        let sizeWithHeight = this.elementRef.nativeElement.querySelector('#users-device-size');
        const sizeScreen = $('#users-device-size').find('div:visible').first().attr('id');
        let windowResize: WindowResize = new WindowResize();
        windowResize.offsetHeight = sizeWithHeight.offsetHeight;
        windowResize.offsetWidth = sizeWithHeight.offsetWidth;
        windowResize.sizeBootStrap = sizeScreen;
        this.windowChanged.emit(windowResize);
    }



}